var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverleagueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#749BBF",
    d: "M61.23 10.165h15.48v7.864c0 3.562-1.425 6.768-4.384 9.864-2.356 2.466-5.644 4.795-9.782 6.932l-1.287-.575V10.165m-6.138-6.137V38.25l7.562 3.37C73.34 36.69 82.903 29.209 82.903 18.058V5.78c0-.986-.795-1.78-1.781-1.78H55.119v.027ZM34.679 10.165V34.25l-1.288.575c-4.137-2.137-7.425-4.466-9.782-6.932-2.96-3.096-4.384-6.302-4.384-9.864v-7.864h15.481m6.138-6.137H14.84c-.986 0-1.78.794-1.78 1.78v12.249c0 11.151 9.534 18.632 20.22 23.564l7.563-3.37V4v.027Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#749BBF",
    d: "M62.764 41.566c-9.837-5.097-19.674-5.097-29.51 0 5.918 3.863 7.836 7.727 5.754 11.617-1.014 1.836 18.851 1.7 17.892-.246-1.89-3.781.082-7.59 5.864-11.371Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0E6FB",
    d: "M54.434 45.895H41.446c-7.343 0-13.453-5.672-14.001-13.015L25.171 2.22A2.06 2.06 0 0 1 27.226 0h41.429c1.205 0 2.164 1.014 2.055 2.22l-2.275 30.66c-.548 7.343-6.658 13.015-14.001 13.015Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFFFF",
    d: "M47.94 18.002V5.782c0-.795-.52-1.453-1.233-1.672H29.884c-.247 0-.466.22-.439.466l2.083 28.003c.11 1.424.52 2.767 1.15 3.973.302.548.96.794 1.535.602 7.973-2.712 13.7-10.247 13.7-19.125l.027-.027ZM66.956 11.18a8.119 8.119 0 0 1-7.097-7.097c0-.083-.11-.083-.11 0a8.119 8.119 0 0 1-7.096 7.096c-.082 0-.082.11 0 .11a8.119 8.119 0 0 1 7.097 7.096c0 .083.11.083.11 0a8.119 8.119 0 0 1 7.096-7.096c.082 0 .082-.11 0-.11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0E6FB",
    d: "M67.805 50.361H28.103a3.093 3.093 0 0 0-3.097 3.096v4.521c0 1.069.877 1.973 1.973 1.973h41.977a1.982 1.982 0 0 0 1.973-1.973v-4.52a3.093 3.093 0 0 0-3.096-3.097h-.028Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverleagueIcon);
export default __webpack_public_path__ + "static/media/silverleagueIcon.df4cba81c045976a43e08e9a61e7cba6.svg";
export { ForwardRef as ReactComponent };